import styled, { css } from 'styled-components';
import { ColorConstants } from '../../../shared/constants';
import { FlexDiv } from '../../../shared/components/base/Div';
import { Image as BaseImage } from '../../../shared/components/base/Image';
import { MobileScreen } from '../../../shared/components/styles/ConstantMediaQuery';
import { Option } from '../../../shared/components/base/List';
import { Text } from '../../../shared/components/base/Text';

export const Title = styled(Text)`
  font-size: 12px;
  font: Helvetica;
  font-weight: normal;
  line-height: 16px;
  text-align: center;
  color: ${ColorConstants['black-50%']};
`;

export const Subtitle = styled(Text)`
  color: ${props => (props.isIntegrated ? ColorConstants.FUN_GREEN : ColorConstants['black-25%'])};
  font: Helvetica;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  text-decoration: ${props => (props.isIntegrated || props.disabled ? '' : 'underline')};
  X constraint: Center
  Y constraint: Top

  svg {
    position: relative;
    top: 3;
  }

`;

export const Image = styled(BaseImage)`
  height: 24px;
  width : 24px;
`;

export const ImageWrapper = styled(FlexDiv)`
  align-items: center;
  border-radius: 10px;
  height: 36px;
  justify-content: center;
  margin-bottom: 5px;
  width: 36px;
`;

export const Item = styled(Option)`
  align-items: center;
  background-color: ${ColorConstants.GRAY_3};
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 121px;
  -webkit-box-pack: center;
  justify-content: center;
  margin: 0px 8px 8px 0px;
  width: 115px;  
  box-shadow: 0px 4px 4px 0px #0000001A;
  position: relative;

  &:hover {
      opacity: 0.8;
  }

  @media ${MobileScreen} {
      margin-bottom: 10px;
  }

  ${({ disabled }) => disabled && css`
      cursor: default;
      opacity: 0.5;
      &:hover {
        opacity: 0.5;
      }
  `}
`;
